import { Constants } from "@constants";
import { createSlice } from "@reduxjs/toolkit";
import apiService from "@utils/apiService";
import { verifyApiResponse } from "@utils/apiResponseHelper";

const initialState = {
  loading: false,
  error: false,
  success: false,
  message: '',
  data: {}
};

export const createYourAssessmentSlice = createSlice({
  name: "createYourAssessment",
  initialState,
  reducers: {
    createYourAssessmentStart: (state) => ({
      ...state,
      loading: true,
      error: false,
      success: false,
      message: ''
    }),
    createYourAssessmentSuccess: (state, action) => ({
      ...state,
      loading: false,
      error: false,
      success: true,
      data: action.payload || {},
    }),
    createYourAssessmentFailure: (state, action) => ({
      ...state,
      loading: false,
      error: true,
      message: action?.payload?.message || ''
    }),
    resetCreateYourAssessment: () => ({
      ...initialState,
    })
  },
});

export const {
  createYourAssessmentStart,
  createYourAssessmentSuccess,
  createYourAssessmentFailure,
  resetCreateYourAssessment,
} = createYourAssessmentSlice.actions;

export const createAssessment = (payload, assessmentCode) => (dispatch) => {
  dispatch(createYourAssessmentStart());

  const apiCall =  apiService.post(`${Constants.API.SCORE_CARD}${Constants.API.CREATE_YOUR_ASSESSMENT}/${assessmentCode}`, payload)
  apiCall.then((response) => {
    let data = verifyApiResponse(response);
    if (data?.systemMessage?.success) {
      let ifDataExists = Object.keys(data?.data);
      if (ifDataExists?.length > 0) {
        dispatch(createYourAssessmentSuccess(data?.data));
      } else {
        dispatch(createYourAssessmentFailure());
      }
    } else {
      dispatch(createYourAssessmentFailure());
    }
  }).catch((error) => {
    if (error?.response?.status === 400) {
      dispatch(createYourAssessmentFailure({
        message : error?.response?.data?.systemMessage?.message
      }));
    } else {
      dispatch(createYourAssessmentFailure())
    }
  })

};

export default createYourAssessmentSlice.reducer;
